import React, { useState } from "react";
import ImageWithBasePath from "../../core/data/img/ImageWithBasePath";
import { Link } from "react-router-dom";
import { CornerDownLeft } from "react-feather";
import { all_routes } from "../router/all_routes";
import { useAuth } from '../../core/context/AuthContext';
import { toast, ToastContainer } from 'react-toastify';
import { useNavigate,useLocation } from "react-router-dom";
import 'react-toastify/dist/ReactToastify.css';

const routes = all_routes;

const SignUp = () => {
  const [isToggle, setIsToggle] = useState(false);
  const [clientname, setClientname] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const { register, login } = useAuth();
  const [passwordError, setPasswordError] = useState('');
  const navigate = useNavigate();
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  const redirectTo = queryParams.get("redirectTo") || "/index";

  console.log("routdirect" , redirectTo);  
  console.log("Attempting to register:", { clientname, email, password });

  // Regex pour valider le mot de passe
  const passwordRegex = /^(?=.*[A-Z])(?=.*[0-9]).{8,}$/; // Au moins 8 caractères, une majuscule et un chiffre

  const handleRegister = async (e: React.FormEvent) => {
    e.preventDefault(); // Prevent default form submission

    // Vérifier si le mot de passe est valide
    if (!passwordRegex.test(password)) {
      setPasswordError("Le mot de passe doit contenir au moins 8 caractères, une lettre majuscule et un chiffre.");
      return;
    }

    try {
      await register(clientname, email, password);
      toast.success('Registration successful!');
      console.log('Registration data:', { clientname, email, password });
      await login(email, password); // Assurez-vous que `login` est disponible dans `useAuth`
      toast.success("Login successful!");
      navigate(redirectTo);
      setClientname('');
      setEmail('');
      setPassword('');
    } catch (error: any) {
      console.error('Registration failed:', error);
      if (error.response && error.response.data) {
        // Show the error message returned from the server
        toast.error(error.response.data.message || 'Registration failed!');
      } else {
        // General error message if no specific error returned
        toast.error(error.message || 'Registration failed!');
      }
    }
  };

  return (
    <div>
      <ToastContainer position="top-right" autoClose={5000} hideProgressBar={false} newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
      <div className="main-wrapper login-body">
        {/* Header */}
        <header className="log-header">
          <Link to={routes.homeOne}>
            <ImageWithBasePath
              className="img-fluid logo-dark"
              src="assets/img/logo.png"
              alt="Logo"
            width={130}

            />
          </Link>
        </header>
        {/* /Header */}
        <div className="login-wrapper">
          <div className="loginbox">
            <div className="login-auth">
              <div className="login-auth-wrap">
                <div className="sign-group">
                  <Link to={routes.homeOne} className="btn sign-up">
                    <span>
                      <CornerDownLeft />
                    </span>{" "}
                    Back To Home
                  </Link>
                </div>
                <h1>Sign Up</h1>
                <p className="account-subtitle">
                  We will send a confirmation code to your email.
                </p>
                <form onSubmit={handleRegister}>
                  <div className="input-block">
                    <label className="form-label">
                      Name <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      value={clientname}
                      onChange={(e) => setClientname(e.target.value)}
                    />
                  </div>
                  <div className="input-block">
                    <label className="form-label">
                      Email <span className="text-danger">*</span>
                    </label>
                    <input
                      type="email"
                      className="form-control"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </div>
                  <div className="input-block">
                    <label className="form-label">
                      Password <span className="text-danger">*</span>
                    </label>
                    <div className="pass-group">
                      <input
                        type={isToggle ? "text" : "password"}
                        className="form-control pass-input"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                      />
                      <span
                        className={`fas toggle-password ${isToggle ? "fa-eye" : "fa-eye-slash"}`}
                        onClick={() => setIsToggle(!isToggle)}
                        style={{ cursor: "pointer" }}
                      />
                    </div>
                    {passwordError && <p className="text-danger">{passwordError}</p>}
                  </div>

                  <button type="submit" className="btn btn-outline-light w-100 btn-size mt-1">
                    Sign Up
                  </button>

                  <div className="login-or">
                    <span className="or-line" />
                    <span className="span-or">
                      Or, Create an account with your email
                    </span>
                  </div>
                  {/* Social Login */}
                  <div className="social-login">
                    <Link
                      to="#"
                      className="d-flex align-items-center justify-content-center input-block btn google-login w-100"
                    >
                      <span>
                        <ImageWithBasePath
                          src="assets/img/icons/google.svg"
                          className="img-fluid"
                          alt="Google"
                        />
                      </span>
                      Log in with Google
                    </Link>
                  </div>
                  <div className="social-login">
                    <Link
                      to="#"
                      className="d-flex align-items-center justify-content-center input-block btn google-login w-100"
                    >
                      <span>
                        <ImageWithBasePath
                          src="assets/img/icons/facebook.svg"
                          className="img-fluid"
                          alt="Facebook"
                        />
                      </span>
                      Log in with Facebook
                    </Link>
                  </div>
                  {/* /Social Login */}
                  <div className="text-center dont-have">
                    Already have an Account? <Link to={routes.login}>Sign In</Link>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        {/* Footer */}
        <footer className="log-footer">
          <div className="container-fluid">
            <div className="copyright">
              <div className="copyright-text">
              <p>© 2025 CARDND  All Rights Reserved Made by <a href="https://openlluna.com/"  target="_blank" rel="noopener noreferrer">OPEN LLUNA</a>.</p>

              </div>
            </div>
          </div>
        </footer>
        {/* /Footer */}
      </div>
    </div>
  );
};

export default SignUp;
